import { SET_ADMIN_DATA } from "../actions/AdminActions";

const initialState = {
    admin: null
};

export default function adminReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ADMIN_DATA:
            return {
                ...state,
                admin: action.payload
            };

        default:
            return state;
    }
}